import { BaseFilterInput } from "../../../common-models/BaseFilterInput";
import { CollectTrackingResultType } from "../../../enums/CollectTrackingResultType";
import { SeparationType } from '../../../enums/SeparationType';

export class GetOrdersInTransportInput extends BaseFilterInput {
  frontVersion?: number|null;
  numbers?: string;
  stateIds?: string;
  shippingStartDate?: any;
  shippingEndDate?: any;
  carrierCode?: string;
  virtualCollect?: string | null;
  collectTrackingResultType?: CollectTrackingResultType | null;
  collectNotDone?: boolean | null;
  lastConsultStatus?: string | null;
  lastConsultStatusIsProblem?: boolean | null;
  locationId?: number | null;
  separationType?: SeparationType | null;
  orderIds?: string;
  includeDeliveredOrders?: boolean;
  periodType?: number | null;
  stateFilterCode?: string;
  userId?: number | null;
  fulfilledBy?: string | null;
  originedBy?: string | null;
  includesCrossChannelSale?: boolean | null;
  onlyCrossChannelSale?: boolean | null;
  fulfillmentLocationIds?: number[] | null;
}